import { z } from "zod"

export const instrumentSchema = z.object({
    serialNumber:   z.string().min(4, "Mínimo 4 caracteres"),
    idOrganization: z.string().min(1, "Campo requerido"),
    equipmentName:  z.string().min(1, "Campo requerido"),
    idBrand:        z.string().min(1, "Campo requerido"),
    model:          z.string().min(1, "Campo requerido"),
    voltage:        z.string().min(1, "Campo requerido"),
    current:        z.string().min(1, "Campo requerido"),
    equipmentType:  z.string().min(1, "Campo requerido"),
})

export type InstrumentSchemaErrors = Partial<Record<keyof z.infer<typeof instrumentSchema>, string>>
